<template>
  <div>
    <back-profile @click.native="navigateTo('app.profile.alerts')">Volver a Alertas</back-profile>
    <block :bordered-header="true">
      <template slot="header">{{ alertTitle(studentAlert) }}</template>
      <template slot="subheader">{{ studentAlert.createdAt | humanizeDate }}</template>
      <template slot="actions">
        <button
          v-if="isAlertActive && canFinishAlert"
          class="button is-danger"
          @click="finishAlert"
        >
          Finalizar Alerta
        </button>
      </template>

      <div v-if="viewer && viewer.institutionCode === 'cuc.co'">
        <div v-if="studentAlert.alertType">
          <!-- Estudiante con beca y/o crédito condonable -->
          <div v-if="studentAlert.alertType.id == '44'" style="font-transform: italic;">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Beca/Crédito:</span>
              <span class="meta-value">{{ studentAlert.student.data.becaDescripcion || "" }}</span>
            </div>

            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Valor beca/crédito:</span>
              <span class="meta-value">{{ studentAlert.student.data.becaValor || "" }}</span>
              <span v-if="studentAlert.student.data.becaValor === 0">0</span>
            </div>

            <div class="meta-item">
              <span class="meta-name has-text-weight-bold"
                >Procentaje de cobertura de la beca/crédito:</span
              >
              <span class="meta-value">{{ studentAlert.student.data.becaCobertura || "" }}</span>
            </div>
          </div>

          <!-- Seguimiento Ruta de Grado -->
          <div v-if="studentAlert.alertType.id == '35'" style="font-transform: italic;">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Porcentaje de créditos aprobados:</span>
              <span class="meta-value">
                {{
                  humanizePercentage(studentAlert.student.data.porcentajeCreditosAprobados) || ""
                }}
              </span>
            </div>
          </div>

          <!-- Seguimiento estudiante diverso -->
          <div v-if="studentAlert.alertType.id == '43'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Inclusión:</span>
              <span class="meta-value">{{ studentAlert.student.data.inclusion || "" }}</span>
            </div>
          </div>

          <!-- Estudiante tiene 8 o más matrículas -->
          <div v-if="studentAlert.alertType.id == '36'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Cantidad de semestres:</span>
              <span class="meta-value">{{ studentAlert.student.data.numSemestres || "" }}</span>
            </div>
          </div>

          <!-- Estudiante tiene 2 o más reintegros -->
          <div v-if="studentAlert.alertType.id == '42'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Número de reintegros:</span>
              <span class="meta-value">{{ studentAlert.student.data.numReintegros || "" }}</span>
            </div>
          </div>

          <!-- Estudiante tiene 5 o más periodos ausentes -->
          <div v-if="studentAlert.alertType.id == '49'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Períodos ausentes:</span>
              <span class="meta-value">{{ studentAlert.student.data.periodosAusentes || "" }}</span>
            </div>
          </div>

          <!-- Estudiante matricula por 2da vez una asignatura -->
          <div v-if="studentAlert.alertType.id == '50'">
            <div class="meta-item">
              <span
                v-if="moreThanOneSubject(studentAlert.student.data.materiasSegundaVezInfo)"
                class="meta-name has-text-weight-bold"
                >Materias inscritas nuevamente:</span
              >
              <span v-else class="meta-name has-text-weight-bold"
                >Materia inscrita nuevamente:</span
              >

              <span class="meta-value">
                {{ studentAlert.student.data.materiasSegundaVezInfo || "" }}
              </span>
            </div>
          </div>

          <!-- Estudiante realizó transferencia interna -->
          <div v-if="studentAlert.alertType.id == '51'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Transferencia interna:</span>
              <span class="meta-value">
                {{ studentAlert.student.data.transferenciaInternaInfo || "" }}
              </span>
            </div>
          </div>

          <!-- Única asignatura matriculada -->
          <div v-if="studentAlert.alertType.id == '52'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold">Única asignatura matriculada:</span>
              <span class="meta-value">{{ studentAlert.student.data.materiaUnicaInfo || "" }}</span>
            </div>
          </div>

          <!-- Retiró asignatura semestre anterior -->
          <div v-if="studentAlert.alertType.id == '57'">
            <div class="meta-item">
              <span class="meta-name has-text-weight-bold"
                >Retiró asignatura semestre anterior:</span
              >
              <span class="meta-value">{{
                studentAlert.student.data.asignaturaRetiradaInfo || ""
              }}</span>
            </div>
          </div>

          <!-- Asignatura perdida semestre anterior -->
          <div v-if="studentAlert.alertType.id == '58'">
            <div class="meta-item here-baby">
              <span class="meta-name has-text-weight-bold"
                >Asignatura perdida semestre anterior:</span
              >
              <span class="meta-value">{{
                studentAlert.student.data.asignaturaPerdidaInfo || ""
              }}</span>
            </div>
          </div>

          <hr
            v-if="alertReasonWasExposed(studentAlert.alertType, studentAlert.alertType.id)"
            class="separator"
          />
        </div>
      </div>

      <div class="meta-list">
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Fecha:</span>
          <span class="meta-value">{{ studentAlert.createdAt | formatStandardDate }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Registrado por:</span>
          <span class="meta-value">{{
            studentAlert.creator ? studentAlert.creator.name : ""
          }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Responsable:</span>
          <span class="meta-value">
            {{ studentAlert.responsible ? studentAlert.responsible.name : "" }}
          </span>
        </div>
        <div class="meta-item">
          <span class="meta-name has-text-weight-bold">Factor de Riesgo:</span>
          <span class="meta-value">{{ alertRiskFactors }}</span>
        </div>
        <div v-if="studentAlert.finishedBy" class="meta-item">
          <span class="meta-name has-text-weight-bold">Finalizada por:</span>
          <span class="meta-value">{{ studentAlert.finishedBy.name }}</span>
        </div>
        <div v-if="studentAlert.finishedAt" class="meta-item">
          <span class="meta-name has-text-weight-bold">Fecha de finalización:</span>
          <span class="meta-value">{{ studentAlert.finishedAt | formatStandardDate }}</span>
        </div>
      </div>
      <div class="description">{{ studentAlert.comment }}</div>
      <div
        v-if="studentAlert.finishComment"
        class="description"
        style="margin-top: 20px; padding-top: 20px; border-top: 1px solid #e0e0e0;"
      >
        <div style="font-weight: bold; margin-bottom: 10px;">Comentario de finalización:</div>
        <div>{{ studentAlert.finishComment }}</div>
      </div>
    </block>
  </div>
</template>

<script>
import gql from "graphql-tag"
import moment from "moment"

import STUDENT_ALERT from "./graphql/StudentAlert.gql"

import Block from "@/components/_base/Block.vue"
import BackProfile from "@/components/_base/BackProfile.vue"

export default {
  name: "ProfileAlert",
  components: {
    Block,
    BackProfile
  },
  props: {
    alertId: {
      type: String
    }
  },
  data() {
    return {
      studentAlert: {
        creator: {
          name: ""
        }
      },
      riskFactorsLabels: {
        ACADEMIC: "Académico",
        ECONOMIC: "Económico",
        VOCATIONAL: "Vocacional",
        INSTITUTIONAL: "Institucional",
        PERSONAL: "Personal",
        OTHER: "Otro",
        VBG: "VBG"
      }
    }
  },
  apollo: {
    studentAlert: {
      query: STUDENT_ALERT,
      variables() {
        return {
          alertId: this.alertId
        }
      }
    },
    viewer: {
      query: gql`
        query {
          viewer {
            institutionCode
          }
        }
      `
    }
  },
  computed: {
    canFinishAlert() {
      const user = localStorage.getItem("user")

      if (user) {
        const userData = JSON.parse(user)
        const userRol = userData.rol.toLowerCase() || ""
        const userInstitutionCode = userData.institution_code || ""

        return userRol === "administrador" && !userInstitutionCode.includes("ulandivar")
      }

      return false
    },
    alertRiskFactors() {
      const riskFactors = this.studentAlert.riskFactors || []
      const labels = riskFactors.map(this.humanizeRiskFactor)
      return labels.join(", ") || "-"
    },
    isAlertActive() {
      // Check if alert is active - handle both isActive (camelCase) and is_active (snake_case)
      const alert = this.studentAlert
      if (!alert) return false

      // Try camelCase first (GraphQL standard conversion)
      if (alert.isActive !== undefined) {
        return alert.isActive === true
      }

      // Fallback to snake_case if camelCase not available
      if (alert.is_active !== undefined) {
        return alert.is_active === true
      }

      // Default to true if field is missing (assume active if not explicitly false)
      return true
    }
  },
  methods: {
    humanizeRiskFactor(code) {
      return this.riskFactorsLabels[code] || code
    },

    alertTitle(alert) {
      // If the alert has a type, use that
      if (alert.alertType) {
        return alert.alertType.name
      }

      const riskFactors = alert.riskFactors || []
      const labels = riskFactors.map(this.humanizeRiskFactor)
      const temp = labels.join(", ") || "*Alerta sin factor de riesgo*"

      return alert.isManual ? `Alerta manual - ${temp}` : temp
    },

    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    },

    humanizePercentage(float) {
      return (float * 100).toFixed(2) + "%"
    },

    moreThanOneSubject(subjects) {
      return subjects.includes(",")
    },

    alertReasonWasExposed(alertType, alertTypeId) {
      const alertIds = ["44", "35", "36", "42", "43", "49", "50", "51", "52", "57", "58"]
      return alertType && alertIds.includes(alertTypeId)
    },

    finishAlert() {
      this.navigateTo({
        state: "app.profile.finish_alert",
        params: {
          alertId: this.alertId
        }
      })
    }
  },

  filters: {
    humanizeDate(date) {
      return date == null ? "-" : moment(date).fromNow()
    },
    formatStandardDate(date) {
      return date === null ? "-" : moment(date).format("DD/MM/YYYY")
    }
  }
}
</script>

<style scoped>
.meta-list {
  margin-bottom: 30px;
}
.meta-item {
  margin-bottom: 10px;
}

.description {
  margin-bottom: 60px;
}

.separator {
  border: 1px solid rgb(224, 224, 224);
  margin: 1.5em 0em;
  border-top: none;
}
</style>
